export var SortColumn;
(function (SortColumn) {
    SortColumn[SortColumn["Date"] = 0] = "Date";
    SortColumn[SortColumn["From"] = 1] = "From";
    SortColumn[SortColumn["Size"] = 2] = "Size";
})(SortColumn || (SortColumn = {}));
//# sourceMappingURL=SortBy.js.map